import { trpc } from '@/shared/api';

/** 카테고리 트리 캐시 무효화 함수를 돌려준다. */
export const useInvalidateCategories = (): (() => void) => {
  const utils = trpc.useUtils();

  return () => void utils.productManagement.categories.list.invalidate();
};
